import React from 'react';
import {convertToJapanCurrency} from "../../shared/constants/global";

export default function CompareIncomingAndSpendingInvestmentGraph(props) {
  const {loggedIn, incomingPercent, totalIncoming, spendingPercent, totalSpending} = props

  return <React.Fragment>
    <h2 className="marB14">【内訳】不動産収支</h2>
    <div className={`resultGraphTxt marB80 ${loggedIn ? '' : "blurCont"}`}>
      <div className="vsGraph vsGraphContainer">
        <div className="incomeRatio" style={{width: `${incomingPercent}%`}}>
          <div className="incomeRatioTitle">不動産収入</div>
          <div className="incomeRatioMoney">{convertToJapanCurrency(totalIncoming)}</div>
        </div>
        <div className="spendingRatio" style={{width: `${spendingPercent}%`}}>
          <div className="spendingRatioTitle">不動産支出</div>
          <div className="spendingRatioMoney">{convertToJapanCurrency(totalSpending)}</div>
        </div>
      </div>
      <p>不動産収支合計<strong>{convertToJapanCurrency(totalIncoming - totalSpending)}</strong></p>
    </div>
  </React.Fragment>
}
